import React from "react";

export const Ornament = ({ className = "", color = "#B8973A" }) => (
  <div
    className={`flex items-center justify-center select-none ${className}`}
    aria-hidden="true"
    data-testid="ornament-divider"
  >
    <span className="inline-block w-12 sm:w-20 h-px" style={{ background: color, opacity: 0.55 }} />
    <span className="mx-4 text-base" style={{ color, fontFamily: "Cormorant Garamond, serif", letterSpacing: "0.2em" }}>
      ✦
    </span>
    <span className="inline-block w-12 sm:w-20 h-px" style={{ background: color, opacity: 0.55 }} />
  </div>
);

export default Ornament;
